export const STATES = [
  { value: 'Abia', viewValue: 'Abia' },
  { value: 'Abuja', viewValue: 'Abuja' },
  { value: 'Adamawa', viewValue: 'Adamawa' },
  { value: 'Akwa Ibom', viewValue: 'Akwa Ibom' },
  { value: 'Anambra', viewValue: 'Anambra' },
  { value: 'Bauchi', viewValue: 'Bauchi' },
  { value: 'Bayelsa', viewValue: 'Bayelsa' },
  { value: 'Benue', viewValue: 'Benue' },
  { value: 'Borno', viewValue: 'Borno' },
  { value: 'Cross River', viewValue: 'Cross River' },
  { value: 'Delta', viewValue: 'Delta' },
  { value: 'Ebonyi', viewValue: 'Ebonyi' },
  { value: 'Edo', viewValue: 'Edo' },
  { value: 'Ekiti', viewValue: 'Ekiti' },
  { value: 'Enugu', viewValue: 'Enugu' },
  { value: 'Gombe', viewValue: 'Gombe' },
  { value: 'Imo', viewValue: 'Imo' },
  { value: 'Jigawa', viewValue: 'Jigawa' },
  { value: 'Kaduna', viewValue: 'Kaduna' },
  { value: 'Kano', viewValue: 'Kano' },
  { value: 'Katsina', viewValue: 'Katsina' },
  { value: 'Kebbi', viewValue: 'Kebbi' },
  { value: 'Kogi', viewValue: 'Kogi' },
  { value: 'Kwara', viewValue: 'Kwara' },
  { value: 'Lagos', viewValue: 'Lagos' },
  { value: 'Nasarawa', viewValue: 'Nasarawa' },
  { value: 'Niger', viewValue: 'Niger' },
  { value: 'Ogun', viewValue: 'Ogun' },
  { value: 'Ondo', viewValue: 'Ondo' },
  { value: 'Osun', viewValue: 'Osun' },
  { value: 'Oyo', viewValue: 'Oyo' },
  { value: 'Plateau', viewValue: 'Plateau' },
  { value: 'Rivers', viewValue: 'Rivers' },
  { value: 'Sokoto', viewValue: 'Sokoto' },
  { value: 'Taraba', viewValue: 'Taraba' },
  { value: 'Yobe', viewValue: 'Yobe' },
  { value: 'Zamfara', viewValue: 'Zamafara' },
];

export interface STATE{
  value: string,
  viewValue: string
}

export const GENDER = ['Male', 'Female'];

export const IDENTIFICATION = [
  'National ID',
  'International Passport',
  'Driver\'s license',
  'Voter\'s Card',
  'e-Tax',
];

export const MARITALSTATUS = ['Married', 'Single', 'Divorced', 'Widowed'];
